import LegalLayout from "@/components/LegalLayout";

function H2({ children }) {
  return (
    <h2 className="mt-10 font-heading text-2xl md:text-3xl"
      style={{ fontVariationSettings: "'opsz' 64, 'wght' 500", color: "var(--ink)" }}>{children}</h2>
  );
}

function P({ children }) { return <p>{children}</p>; }

export default function Terms() {
  return (
    <LegalLayout
      eyebrow="ii. The agreement"
      title="Terms of"
      italic="service."
      lastUpdated="July 17, 2026"
      testid="terms-page"
    >
      <P>
        Welcome to PintaFlow. By creating an account or using the guest demo, you agree to these terms. They are written in plain English so we can both stay sane.
      </P>

      <H2>1. The product</H2>
      <P>
        PintaFlow is a Creator OS — a workspace for capturing ideas, planning content, generating AI-assisted drafts, and tracking your publishing rhythm. It is offered in private beta, free of charge, while we improve it together.
      </P>

      <H2>2. Your account</H2>
      <P>
        You are responsible for what you create inside your workspace. You agree not to use PintaFlow to store illegal content, harass others, or attempt to break the service.
      </P>
      <P>
        You can stop using the product any time. Your data remains yours.
      </P>

      <H2>3. Beta nature</H2>
      <P>
        PintaFlow is in active beta. Things may break, change, or temporarily disappear. We will do our best to give notice for significant changes and to never lose your data — but you should still export important work via CSV from time to time.
      </P>

      <H2>4. AI Co-Pilot</H2>
      <P>
        The AI Co-Pilot generates drafts using large language models. The output is suggestion-grade, not professional advice. You are responsible for editing, fact-checking, and final use of anything generated. Do not paste personal, confidential, or third-party copyrighted text into prompts.
      </P>

      <H2>5. Acceptable use</H2>
      <ul className="list-disc pl-6 space-y-2">
        <li>Don&apos;t reverse engineer, scrape, or resell PintaFlow.</li>
        <li>Don&apos;t use it for spam, hate speech, or anything illegal in India or your country.</li>
        <li>Don&apos;t share your account with others (use it for yourself and your craft).</li>
      </ul>

      <H2>6. Pricing (future)</H2>
      <P>
        While PintaFlow is in private beta, all current features are free. When paid tiers launch, existing beta users will get clear notice and grace-period pricing. You will never be auto-charged without explicit consent. Paid subscriptions come with a <a href="/refund" style={{ color: "var(--seal)" }}>7-day no-questions-asked refund</a>.
      </P>

      <H2>7. AI-generated content ownership</H2>
      <P>
        You own the output of the AI Co-Pilot for your account. We do not claim any rights to your scripts, ideas, or published content. However, because the underlying models are trained on public data, we cannot guarantee that generated text is entirely unique — always review before publishing.
      </P>

      <H2>8. Termination</H2>
      <P>
        We may suspend accounts that violate these terms. If we do, we will email you with the reason and give you a reasonable chance to export your data.
      </P>

      <H2>9. Liability</H2>
      <P>
        PintaFlow is provided &quot;as is&quot;. We are a tiny team and cannot accept liability for indirect or consequential losses. Our total liability is limited to the amount you have paid us in the last 12 months (currently ₹0).
      </P>

      <H2>10. Governing law</H2>
      <P>
        These terms are governed by the laws of India. Any disputes will be handled in the courts of Delhi.
      </P>

      <H2>11. Contact</H2>
      <P>
        Email <a href="mailto:hello@pintaflow.com" style={{ color: "var(--seal)" }}>hello@pintaflow.com</a>. We reply personally — usually within a day.
      </P>
    </LegalLayout>
  );
}
